import * as React from 'react';

const CalendarAddSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#010101"
            d="M21 21H3V9h18v12zM3 8V5h4v1h1V5h8v1h1V5h4v3H3zm14-4V2h-1v2H8V2H7v2H2v18h20V4h-5z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#010101"
            d="M12.5 14.5V12h-1v2.5H9v1h2.5V18h1v-2.5H15v-1z"
        />
    </svg>
);

CalendarAddSvg.displayName = 'CalendarAddSvg';
export default CalendarAddSvg;
